import React from "react";
import SafeAssemblePointPage from "./views/SafeAssemblePointPage";
import { SafeAssemblePointContextProvider } from "./SafeAssemblePointView";
import safeAssemblyPointContent from "../../constants/contentFile.json";

const SafeAssemblePoint = () => {
  return (
    <SafeAssemblePointContextProvider>
      <SafeAssemblePointPage textContents={safeAssemblyPointContent.safeAssemblyPoint} />
    </SafeAssemblePointContextProvider>
  );
};

export default SafeAssemblePoint;
